import { Box, Button } from '@mui/material';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { usePostAuthHome } from 'c-wrapper/Components/CommonWrapper';
import type { TranslationPath } from 'c-translation';
import { Translate } from 'c-translation';
import { makeStyles } from '@mui/styles';
import type { Theme } from '@mui/material/styles';
import LayoutSetter from '../LayoutSetter/LayoutSetter';

const useStyles = makeStyles((theme: Theme) => ({
    status: {
        color: theme.palette.text.secondary,
        fontWeight: 750,
        fontSize: 80,
        bottom: 0,
        height: 'auto',
    },
    title: {
        color: theme.palette.text.secondary,
        fontWeight: 500,
        marginTop: 18,
        marginLeft: 20,
        fontSize: 30,
    },
    message: {
        color: theme.palette.text.secondary,
        fontSize: 15,
    },
    buttonWrap: {
        width: 150,
        float: 'right',
        marginTop: 20,
        right: 0,
        position: 'absolute',
    },
}));
const BadRequest = ({ statusCode, error }: { statusCode: number; error?: string }) => {
    const { pathname } = useLocation();
    const history = useHistory();
    const home = usePostAuthHome();
    const { status, title, message, buttonWrap } = useStyles();

    return (
        <>
            <LayoutSetter metaTitle={pathname as TranslationPath} />
            <Box position="relative" maxWidth={600} ml={10}>
                <Box mt={4} display="flex">
                    <Box className={status}>{statusCode}</Box>
                    <Box className={title}>
                        <Translate
                            path={`BadRequestPage.status.${statusCode}` as TranslationPath}
                        />
                    </Box>
                </Box>
                {error && <Box className={message}>{error}</Box>}
                <Box className={buttonWrap}>
                    <Button variant="contained" color="primary" onClick={() => history.push(home)}>
                        <Translate path={'BadRequestPage.back' as TranslationPath} />
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default BadRequest;
